import React from 'react';
import { FeedbackOption } from '../feedback-config';

interface OptionGroupProps {
  options: readonly FeedbackOption[];
  value: string;
  onChange: (value: string) => void;
  /** Stack options vertically (mobile). Defaults to a horizontal row (desktop). */
  stacked?: boolean;
  error?: string;
  name?: string;
}

/**
 * Single-select answer options rendered as Tailwind pill buttons.
 * Exactly one option can be active; selecting a new one replaces the previous.
 */
const OptionGroup: React.FC<OptionGroupProps> = ({
  options,
  value,
  onChange,
  stacked = false,
  error,
  name,
}) => (
  <div>
    <div
      role='radiogroup'
      className={`flex  ${stacked ? 'flex-col gap-1' : 'flex-wrap gap-0.5'}`}
    >
      {options.map((option, index) => {
        const selected = value === option.value;
        const roundedClass = stacked
          ? 'rounded-4xl'
          : `${index === 0 ? 'rounded-s-4xl' : ''} ${
              index === options.length - 1 ? 'rounded-e-4xl' : ''
            }`;
        return (
          <button
            key={option.value}
            type='button'
            role='radio'
            aria-checked={selected}
            data-testid={name ? `${name}-${option.value}` : undefined}
            onClick={() => onChange(option.value)}
            className={`border px-4! py-3! text-sm! font-medium transition-colors ${roundedClass} ${
              stacked ? 'w-full text-left' : ''
            } ${
              selected
              ? 'border-(--ayvens-theme-brand-primary-400) bg-(--ayvens-theme-brand-primary-400) text-white'
              : 'border-(--ayvens-theme-brand-primary-50) bg-(--ayvens-theme-brand-primary-50) text-(--ayvens-theme-brand-secondary-400) hover:bg-(--ayvens-theme-brand-primary-400) hover:text-white'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
    {error && <p className='mt-2! text-xs! text-red-500!'>{error}</p>}
  </div>
);

export default OptionGroup;
